module.exports = __webpack_public_path__ + "5a7e69e4170ba0bc1010ded07d2c43e7.png";